/**
 * @fileoverview GET handler for the "/engagement/report_builder_2/:report_id/:app_group_id/result" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2Result } from "./constants";
import type { EngagementReportBuilder2AppGroupIdReportIdResult, ReportBuilder2ResultsErrors } from "./types";

export const getReportBuilderReportResults = reactQueryFetcherAdapter(
  engagementReportBuilder2Result,
  createGetFetcherFunctionWithShadowError<ReportBuilder2ResultsErrors>()(
    (
      signal: AbortSignal,
      appGroupId: string,
      reportId: string
    ): Promise<EngagementReportBuilder2AppGroupIdReportIdResult> => {
      return fetch(
        `/engagement/report_builder_2/${reportId}/${appGroupId}/result`,
        "GET",
        {},
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  )
);
